import { TournamentBracketMatchGameStatus } from '@okletsplay/core';

export const CANCELED_TOURNAMENT_BRACKET_STATUS_LABEL: Record<
  TournamentBracketMatchGameStatus,
  string
> = {
  [TournamentBracketMatchGameStatus.Running]: 'Canceled',
  [TournamentBracketMatchGameStatus.Ready]: 'Canceled',
  [TournamentBracketMatchGameStatus.Completed]: 'Finished',
  [TournamentBracketMatchGameStatus.Archived]: 'Finished',
  [TournamentBracketMatchGameStatus.Locked]: 'Canceled',
  [TournamentBracketMatchGameStatus.Waiting]: 'Canceled',
};
